
import { DBMessage, MessageSenderType, MessageTone, MessageStatus, MessageMetadata } from "@/types/message";

// Common type conversions
export const convertToDBMessage = (data: any): DBMessage => ({
  ...data,
  sender_type: data.sender_type as MessageSenderType,
  tone: data.tone as MessageTone | undefined,
  status: data.status as MessageStatus | undefined,
  is_regenerated: Boolean(data.related_to_message_id),
  metadata: data.metadata as MessageMetadata | undefined
});
